/**
 * Loại sự kiện
 */
export default {
  /**
   * Đóng popup kiểm tra báo cáo B01
   */
  ClosePopupCheckReportB01: 1,
  /**
   * Đóng popup kiểm tra báo cáo S05H
   */
  ClosePopupCheckReportS05H: 2,

  /**
   * Show hướng dẫn chuyển chế độ kế toán
   */
  ShowStepConversionAccountingSystem: 3,
};
